import type { QuestionProps } from '../eform.types'

/**
 * FTP's wording for each value, 5 down to 1 (forms_survey_body_mobile.php,
 * question types 1, 2 and 4), so a stored value means the same thing
 * whichever page collected it (R17).
 */
const SCALE_LABELS: Record<number, string[]> = {
  1: ['Strongly Agree', 'Agree', 'No Opinion', 'Disagree', 'Strongly Disagree'],
  2: ['Definitely Yes', 'Probably Yes', 'Neutral', 'Probably Not', 'Definitely Not'],
  4: ['Completely Satisfied', 'Satisfied', 'Somewhat Satisfied', 'Dissatisfied', 'Completely Dissatisfied'],
}

const SCALE_VALUES = ['5', '4', '3', '2', '1']

export default function ScaleQuestion({ question, value, onChange, error }: QuestionProps) {
  const labels = SCALE_LABELS[question.questionType] ?? SCALE_LABELS[1]
  const strValue = Array.isArray(value) ? value[0] ?? '' : value
  const radioName = `scale_${question.orderId}`

  return (
    <div className="space-y-1">
      {labels.map((label, i) => {
        const val = SCALE_VALUES[i]
        const isSelected = strValue === val
        return (
          <label
            key={val}
            className={`flex items-center gap-2.5 rounded-md border px-3 py-2 cursor-pointer transition-all ${
              isSelected
                ? 'border-primary bg-primary/5 ring-1 ring-primary'
                : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'
            }`}
          >
            <input
              type="radio"
              name={radioName}
              value={val}
              checked={isSelected}
              onChange={() => onChange(val)}
              className="sr-only"
            />
            <div
              className={`h-4 w-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
                isSelected ? 'border-primary' : 'border-slate-300'
              }`}
            >
              {isSelected && <div className="h-2 w-2 rounded-full bg-primary" />}
            </div>
            <span className="text-xs text-slate-700">{label}</span>
          </label>
        )
      })}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
